export function checkMousePosition(e: MouseEvent) {
  // All the elements the mouse is currently overlapping with
  const _overlapped = document.elementsFromPoint(
    e.pageX,
    e.pageY - window.scrollY,
  );
  const bgElems = document.querySelectorAll('.bg-logo');

  for (let i = 0; i < _overlapped.length; i++) {
    if (_overlapped[i].classList.contains('_blockLogoHover')) {
      for (let i = 0; i < bgElems.length; i++) {
        bgElems[i].classList.remove('hovering');
      }
      return;
    }
  }

  for (let i = 0; i < _overlapped.length; i++) {
    if (
      _overlapped[i].classList?.contains('bg-logo') &&
      !_overlapped[i].classList.contains('hovering')
    ) {
      _overlapped[i].classList.add('hovering');
    }
  }
  for (let i = 0; i < bgElems.length; i++) {
    if (
      !_overlapped.includes(bgElems[i]) &&
      bgElems[i].classList.contains('hovering')
    )
      bgElems[i].classList.remove('hovering');
  }
}
